import { render, staticRenderFns } from "./costHelpSixtyTage.vue?vue&type=template&id=4e9e8d2d&"
import script from "./costHelpSixtyTage.vue?vue&type=script&lang=js&"
export * from "./costHelpSixtyTage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e9e8d2d')) {
      api.createRecord('4e9e8d2d', component.options)
    } else {
      api.reload('4e9e8d2d', component.options)
    }
    module.hot.accept("./costHelpSixtyTage.vue?vue&type=template&id=4e9e8d2d&", function () {
      api.rerender('4e9e8d2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2FabrPFTM6gCb/JS/costHelpSixtyTage.vue"
export default component.exports